import { NameDto } from '../../Common/Types'
import { TickmillCompanyDto } from './Company'
import { DepartmentDto } from './DepartmentDto'
import { User } from './User'

export interface UserInTeamDto {
  autoAssignmentPausedStart: string | null
  autoAssignmentPausedUntil: string | null
  departments: DepartmentDto[]
  email: string
  id: string
  isPausedAutoAssignment: boolean
  name: string
  status: null | string
}
export interface UserTeamDto {
  id: string
  user: UserInTeamDto
  userData?: User
  team: TeamDto
  autoAssignmentEnabled: boolean
  language: NameDto
  visibility: boolean
}

interface TeamDto {
  id: string
  name: string | null
  region: NameDto
  country: NameDto
  tickmillCompany: TickmillCompanyDto
  isPrimary: boolean
}

export enum UserTeamKey {
  user = 'user.name',
  team = 'team.name',
  autoAssignmentEnabled = 'autoAssignmentEnabled',
  language = 'language.name',
  visibility = 'visibility',
}

export enum UserTeamFilterKey {
  user = 'UserName',
  team = 'TeamId',
  autoAssignmentEnabled = 'AutoAssignment',
  language = 'Language',
  excludeCustomTeams = 'ExcludeCustomTeams',
  visibility = 'Visibility',
}

export enum UserTeamSortKey {
  user = 'User',
}
